import { render, staticRenderFns } from "./clientProfilePriControlGroup.vue?vue&type=template&id=160a6ab0&scoped=true"
import script from "./clientProfilePriControlGroup.vue?vue&type=script&lang=js"
export * from "./clientProfilePriControlGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a6ab0",
  null
  
)

export default component.exports